/* eslint-disable max-params */
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { NoveltyCheckTaskCreator, NoveltyCheckTaskData } from '../novelty-check-task-creator';
import { Logger } from '@patsnap/tahiti-core';
import { CreateNoveltyCheckTaskApi, type CreateNoveltyCheckTaskRequest } from '@/infrastructure/api-functions/core-drafting-api/create-novelty-check-task-api';
import { RetrievalResultReportModel } from '../../models/retrieval-result-report-model';
import { NoveltyCheckReportTitleService } from '../retrieval-result-report-service';
import _ from 'lodash';
import { NOVELTY_CHECK_INPUT_MIN_LENGTH } from '../../constants';
import { I18nService } from '@telecom/shared/services/i18n';
import { InputLanguageDetectionService } from '../input-language-detection-service';
import { ToastError } from '@telecom/shared/utils/toast-error';

@injectable()
export class NoveltyCheckTaskCreatorImpl implements NoveltyCheckTaskCreator {
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(I18nService)
        private readonly _i18n: I18nService,
        @inject(CreateNoveltyCheckTaskApi)
        private readonly _createNoveltyCheckTaskApi: CreateNoveltyCheckTaskApi,
        @inject(RetrievalResultReportModel)
        private readonly _retrievalResultReportModel: RetrievalResultReportModel,
        @inject(NoveltyCheckReportTitleService)
        private readonly _noveltyCheckReportTitleService: NoveltyCheckReportTitleService,
        @inject(InputLanguageDetectionService)
        private readonly _inputLanguageDetectionService: InputLanguageDetectionService,
    ) {}

    async createTask(data: NoveltyCheckTaskData): Promise<void> {
        this._logger.info('查新任务创建服务, 开始创建任务');
        this._validateInputLength(data.text);
        // 检测语言
        await this._inputLanguageDetectionService.detect(data.text);
        await this._createNoveltyCheckTaskRepository(data);
        this._retrievalResultReportModel.update((state) => {
            state.techEssential = data.text;
            state.userInput = data.text;
            return state;
        });
        await this._noveltyCheckReportTitleService.pullNoveltyCheckReportTitle();
        this._logger.info('查新任务创建服务, 创建任务成功');
        return Promise.resolve();
    }

    /**
     * move to repository
     */
    private async _createNoveltyCheckTaskRepository(data: NoveltyCheckTaskData): Promise<void> {
        const request: CreateNoveltyCheckTaskRequest = {
            input: data.text,
            task_id: data.taskId,
            pbd_start: data.pbdStart,
            pbd_end: data.pbdEnd,
        };
        await this._createNoveltyCheckTaskApi.createNoveltyCheckTask(request);
        return;
    }

    /**
     * 客户端验证输入长度
     */
    private _validateInputLength(text: string) {
        const size = _.trim(text).length;
        if (size < NOVELTY_CHECK_INPUT_MIN_LENGTH) {
            const message = this._i18n.t('novelty.check.inputTooShort');
            throw new ToastError(message);
        }
    }
}
